import { render, staticRenderFns } from "./deviceTotalTop.vue?vue&type=template&id=2dcc4ef0&scoped=true"
import script from "./deviceTotalTop.vue?vue&type=script&lang=js"
export * from "./deviceTotalTop.vue?vue&type=script&lang=js"
import style0 from "./deviceTotalTop.vue?vue&type=style&index=0&id=2dcc4ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc4ef0",
  null
  
)

export default component.exports